export default __webpack_public_path__ + "static/media/profile_grey.bcb2bfb9.svg";